// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_AT_RULE_IMPORT_0___ from "-!../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[5].use[1]!../node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[5].use[2]!./styles/fonts.css";
import ___CSS_LOADER_AT_RULE_IMPORT_1___ from "-!../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[5].use[1]!../node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[5].use[2]!./styles/variables.css";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_0___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_1___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Импорт файла шрифтов */
/* Импорт файла с CSS-переменными */

body {
  margin: 0;
  font-family: var(--font-primary), -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen',
    'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue',
    sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  font-weight: var(--font-regular);
  font-size: var(--font-size-md);
  line-height: var(--line-height-normal);
  background-color: var(--color-background);
  color: var(--color-text-primary);
  box-sizing: border-box;
}

code {
  font-family: source-code-pro, Menlo, Monaco, Consolas, 'Courier New',
    monospace;
}

/* Базовые стили для ссылок */
a {
  color: var(--color-text-primary);
  text-decoration: none;
  transition: color 0.2s ease;
}

a:hover {
  color: var(--color-accent);
}

/* Базовые стили для кнопок */
button {
  font-family: var(--font-primary);
  font-weight: var(--font-medium);
  cursor: pointer;
  transition: all 0.2s ease;
}
`, "",{"version":3,"sources":["webpack://./src/index.css"],"names":[],"mappings":"AAAA,yBAAyB;AAEzB,mCAAmC;;AAGnC;EACE,SAAS;EACT;;cAEY;EACZ,mCAAmC;EACnC,kCAAkC;EAClC,gCAAgC;EAChC,8BAA8B;EAC9B,sCAAsC;EACtC,yCAAyC;EACzC,gCAAgC;EAChC,sBAAsB;AACxB;;AAEA;EACE;aACW;AACb;;AAEA,6BAA6B;AAC7B;EACE,gCAAgC;EAChC,qBAAqB;EACrB,2BAA2B;AAC7B;;AAEA;EACE,0BAA0B;AAC5B;;AAEA,6BAA6B;AAC7B;EACE,gCAAgC;EAChC,+BAA+B;EAC/B,eAAe;EACf,yBAAyB;AAC3B","sourcesContent":["/* Импорт файла шрифтов */\n@import './styles/fonts.css';\n/* Импорт файла с CSS-переменными */\n@import './styles/variables.css';\n\nbody {\n  margin: 0;\n  font-family: var(--font-primary), -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen',\n    'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue',\n    sans-serif;\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n  font-weight: var(--font-regular);\n  font-size: var(--font-size-md);\n  line-height: var(--line-height-normal);\n  background-color: var(--color-background);\n  color: var(--color-text-primary);\n  box-sizing: border-box;\n}\n\ncode {\n  font-family: source-code-pro, Menlo, Monaco, Consolas, 'Courier New',\n    monospace;\n}\n\n/* Базовые стили для ссылок */\na {\n  color: var(--color-text-primary);\n  text-decoration: none;\n  transition: color 0.2s ease;\n}\n\na:hover {\n  color: var(--color-accent);\n}\n\n/* Базовые стили для кнопок */\nbutton {\n  font-family: var(--font-primary);\n  font-weight: var(--font-medium);\n  cursor: pointer;\n  transition: all 0.2s ease;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
